import { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
// @mui
import { Card, CardHeader, Box, Select, MenuItem, Typography, CircularProgress, TablePagination, Divider, TableRow, TableContainer, TableBody, Table, TableCell } from '@mui/material';

import { url } from 'src/apiUtils/apiPath';

import { appApi } from 'src/apiUtils/AppApi';
import { alpha, styled } from '@mui/material/styles';
// components
import { useChart } from '../../../components/chart';

import Scrollbar from '../../../components/scrollbar';



// ----------------------------------------------------------------------

AppWebsiteVisits.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
};

export default function AppWebsiteVisits({ title, subheader, borderColor = 'primary' }) {

  return (
    <Card sx={{
      paddingLeft: 1,
      paddingRight: 1,
      paddingBottom: 1,
      height: 306,
      // boxShadow: (theme) => `${alpha(theme.palette[borderColor].dark, 0.07)} 0px 7px 29px 0px`,
      border: (theme) => `1px solid ${alpha(theme.palette[borderColor].dark, 0.24)}`
    }}>
      <Box sx={{
        display: 'flex',
        justifyContent: "center",
        marginBottom: 2,
        color: (theme) => theme.palette[borderColor].dark,
      }}>
        <CardHeader title={title} subheader={subheader} />
      </Box>
      <Box>
        <Scrollbar>
          <TableContainer>
            <Table size="small" aria-label="a dense table">
              <TableBody>
                <TableRow>
                  <TableCell align='left' width={'100%'}><Typography variant="subtitle1">Raj has paid&nbsp; <Box component="span" sx={{ color: "green" }}> Rs.125 </Box> &nbsp;to book the slot of Pandi.</Typography></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align='left' width={'100%'}><Typography variant="subtitle1">Venkat has paid&nbsp; <Box component="span" sx={{ color: "green" }}> Rs.125 </Box> &nbsp;to book the slot of Pandi.</Typography></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align='left' width={'100%'}><Typography variant="subtitle1">Veera has paid&nbsp; <Box component="span" sx={{ color: "green" }}> Rs.125 </Box> &nbsp;to book the slot of Pandi.</Typography></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align='left' width={'100%'}><Typography variant="subtitle1">Ram has paid&nbsp; <Box component="span" sx={{ color: "green" }}> Rs.125 </Box> &nbsp;to book the slot of Dhanush.</Typography></TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align='left' width={'100%'}><Typography variant="subtitle1">Afsal has paid&nbsp; <Box component="span" sx={{ color: "green" }}> Rs.125 </Box> &nbsp;to book the slot of Mani.</Typography></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Scrollbar>
      </Box>

      {/* <Box display={"flex"} justifyContent={"center"} alignContent={'center'} sx={{ padding: 4 }}>
          <Typography sx={{ color: 'red' }}>No Bookings Found</Typography>
        </Box> */}
    </Card >
  );
}
